// React Query mutations for AI-powered SMS generation

import { useApiClient } from '@commander/api-client';
import { useMutation } from '@tanstack/react-query';
import { createSmsAiApi } from '../../api/smsAiApi';
import type { AiGenerationCreateData } from '../../types/aiGeneration';

/**
 * Hook to generate SMS content with AI
 * Returns mutation function to trigger generation and track status
 */
export function useGenerateSms() {
  const apiClient = useApiClient();
  const smsAiApi = createSmsAiApi(apiClient);

  return useMutation({
    mutationFn: (data: AiGenerationCreateData) => smsAiApi.generateSms(data),
  });
}
